export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!

export const WIN_MESSAGES = ['Enhorabona!👏', 'Felicitats!👏', 'Ben fet!👏']
export const GAME_COPIED_MESSAGE = 'Joc copiat'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Falten lletres'
export const WORD_NOT_FOUND_MESSAGE = 'Paraula no trobada'
export const HARD_MODE_ALERT_MESSAGE =
  `Mode difícil nomès pot ser habilitat a l'inici!`
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `El topònim era ${solution}`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `Hauries d'utilitzar ${guess} al lloc ${position}`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `Podria contenir ${letter}`
export const ENTER_TEXT = 'Comprova'
export const DELETE_TEXT = 'Esborra'
export const STATISTICS_TITLE = 'Estadístiques'
export const GUESS_DISTRIBUTION_TEXT = `Distribució d'intents`
export const NEW_WORD_TEXT = 'Nou topònim en '
export const SHARE_TEXT = 'Comparteix'
export const TOTAL_TRIES_TEXT = 'Jugades'
export const SUCCESS_RATE_TEXT = `Èxits(%)`
export const CURRENT_STREAK_TEXT = 'Ratxa actual'
export const BEST_STREAK_TEXT = 'Ratxa màxima'
